import { controls } from "../../controls";
const rprbi31 = {
  label: "SUI",
  starting: true,
  url: "SUI",
  pageLabel: "SUI",
  pageType: "history",
  // filteraction: true,
  filter: [
    ...controls.magicDateLabel({ tab: "filter", label: "From Date", width: "col-sm-2", target: "from_date" }),
    ...controls.magicDate({ tab: "filter", name: "from_date", width: "col-sm-2", dateType: "ontype", default: "sd" }),

    ...controls.magicDateLabel({ tab: "filter", label: "As on Date", width: "col-sm-2", target: "as_on_date" }),
    ...controls.magicDate({ tab: "filter", name: "as_on_date", width: "col-sm-2", dateType: "ontype", default: "sd" }),
  ],
  form: [],
  history: {
    perPage: 10,
    reportHeader: "RBI SUI",
    filterable: true,
    sortable: true,
    defaultsTo: 0,
    pdfProps: { pageSize: "A3", pageOrientation: "landscape" },

    textReportProps: {
      'LBS': {
        filename: `RBI-SUI-$pageData.as_on_date$.txt`,
        format: {},
        separator: "|"
      },
    },
    displayColumns: [
      {
        Header: "State Code",
        accessor: "state_code_RBI",
      },
      {
        Header: "District Code",
        accessor: "district_code_RBI",
      },
      {
        Header: "Block Code",
        accessor: "block_code",
      },
      {
        Header: "No. of Female A/c",
        accessor: "a",
      },
      {
        Header: "Sum of Female Amount",
        accessor: "b",
      },
      {
        Header: "No. of SC Male A/c",
        accessor: "c",
      },
      {
        Header: "Sum of SC Male Amount",
        accessor: "d",
      },
      {
        Header: "No. of ST Male A/c",
        accessor: "e",
      },
      {
        Header: "Sum of ST Male Amount",
        accessor: "f",
      },
    ]
  }
};
export default rprbi31;